import React, { useState, useEffect } from "react";
import Form from 'react-bootstrap/Form';
import Placeholder from "react-bootstrap/Placeholder";

export default function SearchBar(props) {

    const [searchVal, setSearchVal] = useState(props.inputValue);

    useEffect(() => {
        setSearchVal(props.inputValue);
    }, [props.inputValue]);

    const onSearchChange = (e) => {
        const val = e.currentTarget.value;
        setSearchVal(val);
        if(props.onSearchChange) {
            props.onSearchChange(val);
        }
    }

    const handleKeyDown = (e) => {
        if(props.onSearchSubmit && e.key === 'Enter') {
            props.onSearchSubmit(searchVal);
        }
    }

    return (
        <>
            <div className={`position-relative ${props.parentClasses}`}>
                {props.showPlaceholder ?
                    <Placeholder animation={'glow'}>
                        <Placeholder as={Form.Control} aria-label="Loading" disabled />
                    </Placeholder>
                    :
                    <Form.Control
                        data-testid={"search"}
                        onChange={(e) => onSearchChange(e)}
                        onKeyDown={(e) => handleKeyDown(e)}
                        className={`${props.extraClasses}`}
                        type="text"
                        value={searchVal}
                        placeholder={props.placeholder || "Free text search"}
                        autoComplete={props.autocomplete || 'on'} />}
                {props.onSearchSubmit && <div className={'position-absolute top-25 end-5'}>
                    <a className={'link-medium'} onClick={(e) => props.onSearchSubmit(searchVal)}>
                        <i className={`fal fa-${props.searchIcon}`}></i>
                    </a>
                </div>}
            </div>
        </>
    )
}

